module.exports = __webpack_public_path__ + "static/media/broom.4609fcf3.svg";